import { createAsyncThunk } from '@reduxjs/toolkit';

import VerificationProcessApi from 'api/curo/VerificationProcessApi';
import { VerificationProcessActionType } from 'enums/curo/VerificationProcessActionType';

export const createSendEmailVerificationCodeThunk = (api: VerificationProcessApi) =>
  createAsyncThunk(
    VerificationProcessActionType.SendEmailVerificationCode,
    async (applicationId: string) => {
      return api.sendEmailVerificationCode(applicationId);
    },
  );
